module.exports = __webpack_public_path__ + "static/key-verletswing-9ed659026f5106468bfd7a04ae037527.webp";